/**
 * Created by ganlu on 27/12/2016.
 */
import fancyboxController from './fancybox.controller';

export default ($compile, $rootScope, $http, $parse, $timeout, fancyboxService) => {

    "ngInject";

    let service = {
        restrict: 'E',
        scope: {
            options: '=',
            templateUrl: '&',

            onStart: '&', //Will be called right before attempting to load the content
            onCancel: '&', //Will be called after loading is canceled
            onComplete: '&', //Will be called once the content is displayed
            onCleanup: '&', //Will be called just before closing
            onClosed: '&' //Will be called once FancyBox is closed

        },
        require: 'fancybox',
        link: link,
        controller: fancyboxController,
        controllerAs: 'vm'
    };
    return service;

    ////////////////////////////

    function link($scope, $element, $attributes) {
        let fbp = null;

        $scope.$on('$destroy', function () {
            $element.remove();
        });

        init();

        function init() {
            let options = {
                href: $attributes.src,
                boxFor: $attributes.boxFor,
                onOpen: function () {
                    if ($scope.onOpen && $scope.onOpen()) {
                        $scope.onOpen()();
                    }
                },
                onCancel: function () {
                    if ($scope.onCancel && $scope.onCancel()) {
                        $scope.onCancel()();
                    }
                },
                onComplete: function () {
                    onComplete();
                    if ($scope.onComplete && $scope.onComplete()) {
                        $scope.onComplete()();
                    }
                },
                onCleanup: function () {
                    if ($scope.onCleanup && $scope.onCleanup()) {
                        $scope.onCleanup()();
                    }
                },
                onClosed: function () {
                    if ($scope.onClosed && $scope.onClosed()) {
                        $scope.onClosed()();
                    }
                }
            };

            //generic way that sets all (non-function) parameters of fancybox-plus.
            if ($scope.options) {
                angular.extend(options, $scope.options);
            }

            //clean undefined
            for (let key in options) {
                if (options.hasOwnProperty(key)) {
                    if (typeof(options[key]) === 'undefined') {
                        delete options[key];
                    }
                }
            }

            //wait for the DOM view to be ready
            $timeout(function () {
                if (options.boxFor) {
                    //opens the element by id boxFor
                    fbp = $(options.boxFor).fancyboxPlus(options);
                } else if (options.href) {
                    //opens the fancybox-plus using an href.
                    fbp = $.fancyboxPlus(options);
                }
            }, 0);
        }

        function onComplete() {
            $rootScope.$apply(function () {
                let content = $('#fbplus-content');
                $compile(content)($rootScope);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/fancybox-plus/fancybox.directive.js